'use client'

import React from 'react'
import { Dictionary, DictionaryModel, ReplacerObject } from '../../MyStichtingOpenHelpers/src'
import { createContext, ReactNode } from 'react'

interface ComponentTranslationProviderValue {
    getLabel: ([key, defaultValue]: string[], replacer?: ReplacerObject | undefined) => string
}

export const ComponentTranslationContext = createContext<ComponentTranslationProviderValue>({
    getLabel: ([key, defaultValue]: string[], replacer?: ReplacerObject | undefined) => defaultValue ?? key,
})

interface ComponentTranslationProviderProps {
    children: ReactNode
    dictionary: DictionaryModel // translations fetched from CMS
}

export const ComponentTranslationProvider = ({
    children,
    dictionary = {},
}: ComponentTranslationProviderProps): JSX.Element => {
    const getLabel = ([key, defaultValue]: string[], replacer?: ReplacerObject | undefined): string => {
        const value = Dictionary.getText(dictionary, key, replacer)
        if (value === key && defaultValue) return defaultValue
        return value ?? key
    }
    const providerValue: ComponentTranslationProviderValue = { getLabel }

    return <ComponentTranslationContext.Provider value={providerValue}>{children}</ComponentTranslationContext.Provider>
}
